import * as React from 'react'
import { useAppSelector } from '../../../../reducers'
import { selectPromoTypes } from '../../../../reducers/promos'

interface PromoTypeOption {
    name: string;
    value: string;
}

export default function useDisplayTypes(): PromoTypeOption[] {
    const promoTypes = useAppSelector(selectPromoTypes)

    return React.useMemo(() => {
        return promoTypes.sort((a, b) => {
            return a.type.localeCompare(b.type)
        }).map((brand) => ({
            name: brand.type,
            value: brand.type,
        }))
    }, [promoTypes])
}
